// This is used any time we want to check to see if a location falls within a group etc.

export enum LocationScope {
  ORG = "org",
  GROUP = "group",
  LOCATION = "location",
}
export interface LocationsMatrix {
  orgId?: number; // Org IDs
  groupIds?: number[]; // Group IDs
  locationIds?: number[]; // Location IDs
}

export interface LocationMatrixWithValuesValue<T> {
  id: number;
  value: T;
}
export interface LocationMatrixWithValues<T> {
  org?: LocationMatrixWithValuesValue<T>; // Org IDs
  groups?: LocationMatrixWithValuesValue<T>[]; // Group IDs
  locations?: LocationMatrixWithValuesValue<T>[]; // Location IDs
}
